import React from "react";
import { Icon } from "antd";

export const TENDENCIA_ESTILO = {
    up: { color: "#16a34a", icon: "arrow-up" },
    down: { color: "#dc2626", icon: "arrow-down" },
    flat: { color: "#64748b", icon: "arrow-right" },
};

export function Tendencia(props) {
    const estilo = TENDENCIA_ESTILO[props.direccion] || TENDENCIA_ESTILO.flat;
    return (
        <div className="inv-tendencia">
            <span className="inv-tendencia-valor" style={{ color: estilo.color }}>
                <Icon type={estilo.icon} /> {props.valor}
            </span>
            {` ${props.texto}`}
        </div>
    );
}

export default function KpiCard(props) {
    return (
        <div className="inv-kpi-card">
            <div className="inv-kpi-icon" style={{ backgroundColor: props.iconBackground, color: props.iconColor }}>
                <Icon type={props.icon} />
            </div>
            <div className="inv-kpi-body">
                <div className="inv-kpi-label">{props.label}</div>
                <div className="inv-kpi-value" style={{ color: props.valueColor }}>{props.value}</div>
                <Tendencia direccion={props.tendenciaDireccion} valor={props.tendenciaValor} texto={props.tendenciaTexto} />
            </div>
        </div>
    );
}
